import { connect } from 'react-redux'
import { signUp } from 'redux/modules/auth'

import SignupComponent from '../components/SignupComponent'

const mapActionCreators = {
  signUp
}

const mapStateToProps = state => ({
  auth: state.auth
})

export default connect(mapStateToProps, mapActionCreators)(SignupComponent)



// WEBPACK FOOTER //
// ./src/routes/Signup/containers/SignupContainer.js